// extracted by mini-css-extract-plugin
module.exports = {"imageSlider":"CoursesSlider_imageSlider__3ZLlM","image":"CoursesSlider_image__2riE_","video":"CoursesSlider_video__20LBi","textWrapper":"CoursesSlider_textWrapper__1WcX1"};